<template>
  <portal to="modals" v-if="$store.state.modals.enquiryModal">
    <modal-component
      :show="true"
      @close="closeModal"
      container-classes="max-w-content-xl my-12.5 md:my-0"
      wrapper-classes="flex"
    >
      <div class="md:flex w-full max-w-screen-xl mx-auto lg:rounded-lg overflow-hidden">
        <div class="flex-auto w-full md:w-4/12 p-5 md:py-20 md:px-10 bg-white">
          <slot></slot> 
        </div> 
        <div class="flex-auto w-full p-5 md:p-20 bg-grey-lightest">
          <enquiry-form :allow-newsletter-signup="allowNewsletterSignup"></enquiry-form>
        </div>
      </div>
    </modal-component>
  </portal>
</template>

<script>
import ModalComponent from './ModalComponent.vue';
import EnquiryForm from './EnquiryForm.vue';

export default {
  components: { ModalComponent, EnquiryForm },

  props: {
    allowNewsletterSignup: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    closeModal() {
      this.$store.commit('modals/SET_SHOW_ENQUIRY_MODAL', false);
    },
  },
};
</script>
